import { SVGProps } from "react";

const STILastpass = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="LastPass" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#d32d27" /><g strokeLinecap="round" stroke="#fff"><path d="M108 256zm119 0zm120 0z" strokeWidth={88} /><path d="M438 170 v172" strokeWidth={20} /></g></svg>;

export { STILastpass };